import { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { subscribeServerUnavailable } from '@/services/serverUnavailable';

const ServerUnavailableBanner = () => {
  const [state, setState] = useState({ active: false, message: '' });

  useEffect(() => subscribeServerUnavailable(setState), []);

  if (!state.active) return null;

  return (
    <div
      className="fixed top-0 inset-x-0 z-[100] bg-amber-500 text-amber-950 px-4 py-2 text-sm shadow-md"
      role="status"
      data-testid="server-unavailable-banner"
    >
      <div className="max-w-6xl mx-auto flex items-center justify-center gap-2 text-center">
        <Loader2 className="w-4 h-4 animate-spin shrink-0" />
        <span>{state.message || 'Server is restarting. Please wait a few seconds and retry.'}</span>
      </div>
    </div>
  );
};

export default ServerUnavailableBanner;
